export const RESTORED_FILTERS_QUERY_PARAM = "restored_filters";
export const RESTORED_FILTERS_ENABLED_VALUE = "true";

/**
 * Checks if restored_filters query param is set to "true"
 */
export const isRestoredFiltersEnabled = (value: string | string[] | undefined): boolean => {
    return value === "true";
};
